/**
 * Route for `entry-level-299-month`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EntryLevel299MonthPage } from "../features/entry-level-299-month/EntryLevel299MonthPage";

export const entryLevel299MonthRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/entry-level-299-month",
	component: EntryLevel299MonthPage,
});

export default entryLevel299MonthRoute;
